module.exports = __webpack_public_path__ + "static/young-smiling-woman-sitting-in-cafe-82a67876bf117270006dcd087c0863ed.jpg";